export default "__VITE_ASSET__D6e63U3T__"